import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={active}>
        <span
          class="ns-anchor ns-relative ns-w-100 ns-border-box ns-p-4 nosto-facet-title"
          data-nosto-element="facet"
          onClick={() => {
            setActive(!active)
        }}
          aria-controls={`${facet.id}-sub-menu`}
          aria-label={`${active ? "Collapse" : "Expand"} ${facet.name}`}
        >
          <span class="ns-color-black ns-facet-name">{facet.name}</span>
          <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M12 6v12M6 12h12"
            />
          </svg>
        </span>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <RangeSlider id={facet.id} />
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2 nosto-range-container">
                        {/* <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1 nosto-range-container">
                        {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
            </div>
        </li>
    )
}
